import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'
import moment from 'moment'

const Wrapper = styled.div``

const Acceptance = (props) => {
  const { avisTime } = props

  const avis = useMemo(() => {
    const ms = moment(avisTime).valueOf() - moment().valueOf()
    const duration = moment.duration(ms)
    const late = duration.asSeconds() < 0
    const minutes = Math.abs(Math.round(duration.asMinutes()))
    const hours = Math.abs(Math.round(duration.asHours()))
    const restMinutes = hours % 60
    if (late) {
      return null
    }
    if (Math.abs(minutes) < 120) {
      return i18n.t('x_minutes_short', {
        defaultValue: '{{minutes}} Min.',
        minutes,
      })
    }
    return i18n.t('x_hours_short', {
      defaultValue: '{{hours}} Std.',
      hours,
    })
  }, [avisTime])

  return (
    <Wrapper>
      {avis ? (
        <span>
          {i18n.t('time_remaining_for_acceptance', 'Zeit bis zur letztmöglichen Auftragsannahme')}:{' '}
          <strong className="text-success">{avis}</strong>
        </span>
      ) : (
        <strong className="text-danger">
          {i18n.t(
            'acceptance_not_possible_anymore_today_pickup_delivery_v3',
            'Abholung/Zustellung heute nicht mehr möglich. Bitte wählen Sie oberhalb den nächsten (Werk)tag als Datum.'
          )}
        </strong>
      )}
    </Wrapper>
  )
}

export default Acceptance
